import React, { useState, useEffect } from 'react';
import AppRouter from './router';
import AuthUser from './components/AuthUser';
import { jwtDecode } from 'jwt-decode';
import isEmpty from "./utils/isEmpty"; // Импортируем функцию
import { checkForNewVersion } from './versionCheck';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  useEffect(() => {
    checkForNewVersion();
  }, []);
  // Функция проверки авторизации
  const checkAuth = () => {
    const token = localStorage.getItem('jwtToken');
    if (!token || token == "undefined" || token == "null") return false;

    try {
      const { exp } = jwtDecode(token);
      return Date.now() < exp * 1000;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    const verifyAuth = async () => {
      const authenticated = !isEmpty(localStorage.getItem('jwtToken')) && localStorage.getItem('jwtToken') != "undefined" && checkAuth();
      setIsAuthenticated(authenticated);
      setIsCheckingAuth(false);
    };

    verifyAuth();

    const isIPhone = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isIPhone) {
      document.documentElement.classList.add("is-iphone");
    }
  }, []);

  if (isCheckingAuth) {
    return <div className="auth-loader">
  </div>;
  }

  return (
      isAuthenticated ? (
          <AppRouter />
    ) : (<AuthUser onAuthSuccess={() => setIsAuthenticated(true)} />)
  );
};

export default App;